import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class GetlinkService {

  constructor(
    private router: Router
  ) { }

  getLink(type, title, lienExterne, addPersonas, addFonctions, titleHome) {

    let url = null;
    switch (type) {
      case 'Flux Actu':
        url = 'rss';
        break;
      case 'Flux Autre':
        url = 'rss';
        break;
      case 'Lien Externe Application':
        url = 'url';
        break;
      case 'Youtube':
        url = 'youtube';
        break;
      case 'Label Valeur':
        url = 'lv';
        break;
      case 'Lien Externe Application':
        url = 'out';
        break;
      default:
        break;
    }

    (url === null) ?
      title === 'actus-ligue' ?
        this.router.navigate([`${title}`, { addPers: addPersonas, addFonc: addFonctions }]) :
        this.router.navigate([`${title}`]) :

      type === 'Label Valeur' || type === 'Youtube' ?
        this.router.navigate([`${url}`, { name: title, externalUrl: lienExterne, title: titleHome }]) :
        this.router.navigate([`${url}`, { name: title, externalUrl: lienExterne }]);
  }


}
